/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Create_Private_ThreadsInputs */



/**
* | output |
* | --- |
* | "Create Private Threads" |
*
* @param {Leveling_Perm_Create_Private_ThreadsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_create_private_threads = /** @type {((inputs?: Leveling_Perm_Create_Private_ThreadsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Create_Private_ThreadsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создавать приватные ветки")
	return /** @type {LocalizedString} */ ("Create Private Threads")
});